import { SigningService } from '@buyerflo/core/schemas/esign'
import Button from 'components/button'
import { Dialog, Text, XStack } from 'tamagui'
import { useShowSnack } from 'components/snackbar'
import { usePurchaserContext } from '../purchaserProvider'

interface Props {
    open: boolean
    onClose: (url?: string) => void
    formType: string
    signingService: SigningService
    title?: string
    message?: string
}

const UploadFormModal = ({
    open,
    onClose,
    formType,
    signingService,
    title = 'Upload Form',
    message = 'Upload functionality for documents is not yet implemented.',
}: Props) => {
    const { purchaser } = usePurchaserContext()
    const showSnack = useShowSnack()

    const handleUpload = async () => {
        try {
            showSnack('Upload functionality not implemented yet', 'warning')
            onClose()
        } catch (error) {
            console.error('Error uploading form:', error)
            showSnack('Error uploading form', 'danger')
        }
    }

    return (
        <Dialog open={open} onOpenChange={(isOpen) => { if (!isOpen) onClose() }}>
            <Dialog.Portal>
                <Dialog.Overlay key="overlay" backgroundColor="$overlay" />
                <Dialog.Content key="content" bordered elevate padding="$4" borderRadius="$4">
                    <Dialog.Close asChild>
                        <Button size="$3" circular position="absolute" top="$2" right="$2" onPress={() => onClose()}>
                            X
                        </Button>
                    </Dialog.Close>
                    <Dialog.Title>{title}</Dialog.Title>
                    <Dialog.Description>
                        <Text>{message}</Text>
                    </Dialog.Description>
                    <XStack gap="$2" flexDirection="row-reverse" marginTop="$4">
                        <Button
                            variant="outlined"
                            onPress={() => onClose()}
                        >
                            Cancel
                        </Button>
                        <Button
                            onPress={handleUpload}
                        >
                            Upload
                        </Button>
                    </XStack>
                </Dialog.Content>
            </Dialog.Portal>
        </Dialog>
    )
}

export default UploadFormModal
